module.exports = __webpack_public_path__ + "static/img/cooperation-detail.cfea74fb.png";